import { render, staticRenderFns } from "./cardHistogram.vue?vue&type=template&id=27a9cd3c&scoped=true&"
import script from "./cardHistogram.vue?vue&type=script&lang=js&"
export * from "./cardHistogram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a9cd3c",
  null
  
)

export default component.exports